export interface CandidatesRouter {
  goToCreate: (values: { companyId: string; profileType: string }) => void;
  goToDetail: (id: string) => void;
  goToList: (query?: string) => void;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CandidatesRouter = Symbol('CandidatesRouter');
